module.exports = __webpack_public_path__ + "static/media/Hohe-qualitaet2.5d6e75da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Hohe-qualitaet2.jpg
// module id = 231
// module chunks = 8